import { render, staticRenderFns } from "./OfferView.vue?vue&type=template&id=fdfd8396"
import script from "./OfferView.vue?vue&type=script&lang=js"
export * from "./OfferView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports